/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\CategorySVG\Citycar.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday March 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 13th 2023 2:18:01 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */
import { SVGProps } from 'Content/SVG/SVGProps';

function Citycar(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} stroke={props.stroke} strokeWidth={props.strokeWidth} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M905.81,557.8c-.41-7.21-1.14-13.84-2.33-19.32-16.56-76.16-77-198.88-208.61-198.88h-92.71c-163.91,0-194.39,84.2-257.45,125.07,0,0-81.73,31.58-105.82,37.49-18.35,4.5-32.54,12.91-43.24,22.48-.03,0-.07,0-.1,0-.38,.35-.7,.71-1.07,1.06-1.67,1.54-3.25,3.1-4.74,4.69-.6,.63-1.16,1.27-1.73,1.9-1.44,1.62-2.82,3.24-4.09,4.88-.51,.66-.98,1.31-1.46,1.96-1.05,1.43-2.05,2.86-2.97,4.27-.56,.86-1.09,1.71-1.6,2.56-.74,1.22-1.44,2.43-2.08,3.63-.24,.45-.55,.92-.78,1.36-1.06,2.05-2.04,4.47-2.97,7.11-.21,.6-.42,1.22-.62,1.85-.18,.55-.36,1.11-.54,1.68-.32,1.05-.64,2.12-.95,3.22,0,.02-.01,.04-.02,.06h0c-5.5,19.81-8.13,48-8.15,63.53,0,.05,0,.11,0,.16,0,0,0,0,0,0,0,0,0,.02,0,.02,0,22.63,15.17,31.22,29.8,31.22h60.13c-.04,.98-.15,1.93-.15,2.92,0,42.9,34.77,77.66,77.67,77.66s77.65-34.77,77.65-77.66c0-.98-.11-1.94-.15-2.92h262.55c-.04,.98-.15,1.93-.15,2.92,0,42.9,34.78,77.66,77.67,77.66s77.66-34.77,77.66-77.66c0-.98-.11-1.94-.15-2.92h55.96c14.63,0,21.93-17.24,23.18-31.72,.14-1.6,.28-3.31,.43-5.09,.33-4,.68-8.35,1-13.24h-.02c.32-4.84,.61-9.95,.85-15.2,7.27-2.5,12.49-9.29,12.49-17.41v-2.12c0-7.94-5.38-14.61-12.41-17.24Z"/>
        </svg>
    );
}

export default Citycar;
